import React from 'react';
import { Search, Zap, Leaf, Droplet, Sparkles } from 'lucide-react';
export const Experience = () => {
  const steps = [{
    icon: <Search className="w-5 h-5 metallic-gold-icon" data-id="element-67" />,
    title: 'Diagnóstico capilar',
    desc: 'Analizamos tu cabello antes de tocar un solo producto'
  }, {
    icon: <Zap className="w-5 h-5 metallic-gold-icon" data-id="element-68" />,
    title: 'Alta frecuencia',
    desc: 'Estimula el cuero cabelludo y fortalece desde la raíz'
  }, {
    icon: <Leaf className="w-5 h-5 metallic-gold-icon" data-id="element-69" />,
    title: 'Detox con arcillas',
    desc: 'Purifica, elimina toxinas y prepara tu cabello'
  }, {
    icon: <Droplet className="w-5 h-5 metallic-gold-icon" data-id="element-70" />,
    title: 'Hipernutrición',
    desc: 'Vitaminas, hidratación profunda y brillo espectacular'
  }, {
    icon: <Sparkles className="w-5 h-5 metallic-gold-icon" data-id="element-71" />,
    title: 'Nanoplastia Orgánica',
    desc: 'El alisado que transforma sin dañar'
  }];
  return <section className="py-16 bg-beige-50" data-id="element-72">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-73">
        <div className="text-center mb-16" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-serif text-neutral-900 mb-4" data-id="element-75">
            Esto no es solo un alisado — es una{' '}
            <br className="hidden md:block" data-id="element-76" />
            <span className="metallic-gold-text italic" data-id="element-77">
              experiencia capilar PREMIUM
            </span>
          </h2>
          <p className="text-neutral-600 max-w-2xl mx-auto" data-id="element-78">
            Cuando entras a nuestro salón, no eres un número más. Eres una mujer
            que merece atención real, resultados reales y un cabello que refleje
            quien eres. Por eso cada visita incluye:
          </p>
        </div>

        <div className="relative" data-id="element-79">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-gold-200 to-transparent -translate-y-1/2 z-0" data-id="element-80"></div>

          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 relative z-10" data-id="element-81">
            {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center group" data-id="element-82">
                <div className="w-16 h-16 bg-white rounded-full shadow-md border-2 border-gold-100 flex items-center justify-center mb-4 group-hover:border-gold-400 group-hover:shadow-lg transition-all duration-300 relative" data-id="element-83">
                  {/* Step number indicator — champagne metallic */}
                  <div className="absolute -top-2 -right-2 w-6 h-6 metallic-gold-button text-xs font-bold rounded-full flex items-center justify-center" data-id="element-84">
                    {index + 1}
                  </div>
                  {step.icon}
                </div>
                <h3 className="font-serif font-medium text-neutral-900 text-lg mb-2" data-id="element-85">
                  {step.title}
                </h3>
                <p className="text-sm text-neutral-500 leading-relaxed" data-id="element-86">
                  {step.desc}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};